module.exports = __webpack_public_path__ + "img/price-per-store.70f33aa3.png";